
export default {
  props: ['to', 'index', 'step'],
  data () {
    return {
      activeStyles: ['active', 'disabled']
    }
  },
  computed: {
    currentTab () {
      return this.index === this.step
    },
    followingTab () {
      return this.index > this.step
    },
    styles () {
      if (this.currentTab) {
        return this.activeStyles
      }
      if (this.followingTab) {
        return ['disabled']
      }
      return []
    }
  }
}
